import { Card, CardContent } from "@/components/ui/card";
import { ReactNode } from "react";

interface DashboardCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  subtitle?: string;
  changeValue?: number;
  iconBgClass?: string;
  iconTextClass?: string;
}

export function DashboardCard({
  title,
  value,
  icon,
  subtitle,
  changeValue,
  iconBgClass = "bg-primary/10",
  iconTextClass = "text-primary"
}: DashboardCardProps) {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex justify-between mb-4">
          <div>
            <h3 className="text-lg font-semibold mb-1">{title}</h3>
            {subtitle && <p className="text-muted-foreground text-sm">{subtitle}</p>}
          </div>
          <div className={`flex h-10 w-10 items-center justify-center rounded-full ${iconBgClass}`}>
            <div className={iconTextClass}>{icon}</div>
          </div>
        </div>
        <div className="space-y-1">
          <p className="text-2xl font-bold">{value}</p>
          {changeValue !== undefined && (
            <p className={changeValue >= 0 ? "text-green-500 text-sm" : "text-red-500 text-sm"}>
              {changeValue >= 0 ? "+" : ""}{changeValue}% from last month
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}